// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QMW1","questions":"styles_questions__2SpMt","footer":"styles_footer__3zL3h"};